import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const getTimeOffRequest = async () => {
  const response: AxiosResponse = await apiInstance.get("/time-off");

  return response.data;
};
